<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Histórico de consultas</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="consultar" class="btn-info btn--bigger">
            <i class="fa fa-search"></i>
            <span>Consultar</span>
          </button>
          <button @click="exportar" class="btn-success btn--bigger">
            <i class="fa fa-file-excel-o"></i>
            <span>Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Filtros de la consulta</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div
              class="form-field select2"
              :class="{
                            'select2--disabled' : doctores.length === 1
                        }"
            >
              <div class="select2-field">
                <v-select
                  @input="inputDoctor"
                  label="nombre"
                  v-model="selectedDoctor"
                  id="doctor"
                  placeholder="Seleccione..."
                  :options="doctores"
                ></v-select>
                <label for="doctor">Médico</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  @input="inputPaciente"
                  label="nombre_completo"
                  v-model="selectedPaciente"
                  id="paciente"
                  placeholder="Seleccione..."
                  :options="pacientes"
                ></v-select>
                <label for="paciente">Paciente</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select @change="consultar" name="estado" v-model="form.estado" id="estado">
                  <option value>Todos los estados</option>
                  <option value="P">Pendientes</option>
                  <option value="I">Iniciadas</option>
                  <option value="R">Rechazadas</option>
                  <option value="F">Finalizadas</option>
                </select>
                <label for="estado">Estado</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-inline">
              <p>
                <strong>Fecha</strong>
              </p>
              <label for="hoy">
                <input
                  @change="consultar"
                  type="radio"
                  name="tipo_fecha"
                  id="hoy"
                  v-model="form.tipo_fecha"
                  value="H"
                />
                <span>Hoy</span>
              </label>
              <label for="ayer">
                <input
                  @change="consultar"
                  type="radio"
                  name="tipo_fecha"
                  id="ayer"
                  v-model="form.tipo_fecha"
                  value="A"
                />
                <span>Ayer</span>
              </label>
              <label for="personalizado">
                <input
                  @change="changePersonalizado"
                  type="radio"
                  name="tipo_fecha"
                  id="personalizado"
                  v-model="form.tipo_fecha"
                  value="P"
                />
                <span>Personalizado</span>
              </label>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="desde"
                  label="YYYY-MM-DD"
                  v-model="form.desde"
                  locale="es"
                  no-label
                  only-date
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                />
                <label for="desde">Desde</label>
                <span v-if="errores.desde" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.desde[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="hasta"
                  v-model="form.hasta"
                  locale="es"
                  no-label
                  only-date
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  label="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                />
                <label for="hasta">Hasta</label>
                <span v-if="errores.hasta" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.hasta[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-2">
      <div class="card__title">
        <h5>Resultados de la consulta</h5>
      </div>
      <div class="card__content">
        <div class="table-responsive">
          <k-table
            @verMedios="verMedios"
            estadoInactivo="R"
            @errores="onErrores"
            @txt="verTxt"
            @zip="descargarZip"
            :buscarButton="false"
            :filterStatus="false"
            :params="form"
            ref="consultas"
            :path="path"
            :createButton="false"
            :editButton="false"
            :deleteButton="false"
            :buttons="[
                    {
                        icon : 'fa-file',
                        event : 'txt',
                        class : 'btn-info'
                    },
                    {
                        icon : 'fa-download',
                        event : 'zip',
                        class : 'btn-primary'
                    },
                    {
                        icon : 'fa-play',
                        event : 'verMedios',
                        class : 'btn-secondary'
                    }
                ]"
            :columns="[
                    {
                        display: 'Médico',
                        value: 'doctor.nombre'
                    },
                    {
                        display: 'Paciente',
                        value: 'paciente.nombre_completo'
                    },
                    {
                        display: 'Cédula',
                        value: 'paciente.identificacion'
                    },
                    {
                        display: 'Fecha de inicio',
                        value: 'fecha_inicio'
                    },
                    {
                        display: 'Fecha de fin',
                        value: 'fecha_fin'
                    },
                    {
                        display: 'Valor de consulta',
                        value: 'valor_consulta'
                    },
                    {
                      display: '# Transacción',
                      value: 'transaccion_id'
                    },
                    {
                      display: 'Tarjeta',
                      value: 'descripcion_tipo_tarjeta'
                    },
                    {
                        display: 'Estado',
                        value: 'descripcion_estado'
                    }
                ]"
          ></k-table>
        </div>
      </div>
    </div>
    <modal name="galeriaMedios" height="auto" width="70%" scrollable adaptive resizable reset>
      <galeria-medios @cerrar="$modal.hide('galeriaMedios')" :consultaId="currentConsultaId"></galeria-medios>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    path: {
      type: String,
      required: false,
      default: url + "/consultas"
    },
    doctores: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    pacientes: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      selectedDoctor: null,
      selectedPaciente: null,
      form: {
        desde: "",
        hasta: "",
        doctor_id: "",
        paciente_id: "",
        tipo_fecha: "H",
        estado: ""
      },
      errores: {},
      currentConsultaId: ''
    };
  },
  methods: {
    verMedios: function (row) {
      this.currentConsultaId = row.id;
      this.$modal.show('galeriaMedios');
    },
    exportar: function() {
      this.$refs.consultas.exportar();
    },
    inputDoctor: function() {
      if (this.selectedDoctor !== null)
        this.form.doctor_id = this.selectedDoctor.id;
      else this.form.doctor_id = "";
    },
    inputPaciente: function() {
      if (this.selectedPaciente !== null)
        this.form.paciente_id = this.selectedPaciente.id;
      else this.form.paciente_id = "";
    },
    onErrores: function(errores) {
      this.errores = errores;
    },
    descargarZip: function(consulta) {
      if (consulta.url_zip !== null) window.open(consulta.url_zip, "_blank");
      else swal("No hay archivos por descargar.", "Aviso", "warning");
    },
    verTxt: function(consulta) {
      if (consulta.url_txt !== null) {
        let link = document.createElement("a");
        let filename = consulta.url_txt.substring(
          consulta.url_txt.lastIndexOf("/") + 1
        );
        link.download = filename;
        link.href = consulta.url_txt;
        link.click();
      } else swal("La consulta no tuvo mensajes de chat.", "Aviso", "warning");
    },
    changePersonalizado: function() {
      let desde = new Date();
      this.form.hasta = moment(desde).format("YYYY-MM-DD");
      desde.setDate(desde.getDate() - 7);
      this.form.desde = moment(desde).format("YYYY-MM-DD");
      this.consultar();
    },
    consultar: function() {
      this.$refs.consultas.loadRows();
    }
  },
  mounted: function() {
    if (this.doctores.length === 1) {
      this.selectedDoctor = this.doctores[0];
      this.inputDoctor();
    }
    if (this.pacientes.length === 1) {
      this.selectedPaciente = this.pacientes[0];
      this.inputPaciente();
    }
    this.consultar();
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/consultas/HistoricoConsultas.vue